import { Search, X } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  'aria-label'?: string
}

export function SearchInput({
  value,
  onChange,
  placeholder = 'ค้นหา...',
  className,
  'aria-label': ariaLabel,
}: SearchInputProps) {
  return (
    <div className={cn('relative', className)}>
      <Search
        className="text-muted-foreground absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2"
        aria-hidden="true"
      />
      <input
        type="search"
        value={value}
        onChange={(e) => {
          onChange(e.target.value)
        }}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className={cn(
          'border-input bg-background text-foreground w-full rounded-md border py-2 pr-8 pl-9 text-sm',
          'placeholder:text-muted-foreground',
          'focus:border-ring focus:ring-ring focus:ring-1 focus:outline-none'
        )}
      />
      {value && (
        <button
          onClick={() => {
            onChange('')
          }}
          className="text-muted-foreground hover:bg-accent hover:text-foreground focus:ring-ring absolute top-1/2 right-2 -translate-y-1/2 rounded-full p-0.5 focus:ring-2 focus:outline-none"
          aria-label="ล้างการค้นหา"
          type="button"
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      )}
    </div>
  )
}
